import apiClient from "@/api/client";

export interface ListSecretsResponse {
  tenant_slug: string;
  secrets: string[];
}

export interface ReadSecretResponse {
  path: string;
  data: Record<string, string>;
}

export async function listTenantSecrets(
  slug: string,
): Promise<ListSecretsResponse> {
  const { data } = await apiClient.get<ListSecretsResponse>(
    `/admin/vault/${encodeURIComponent(slug)}`,
  );
  return data;
}

export async function readTenantSecret(
  slug: string,
  name: string,
): Promise<ReadSecretResponse> {
  const { data } = await apiClient.get<ReadSecretResponse>(
    `/admin/vault/${encodeURIComponent(slug)}/${encodeURIComponent(name)}`,
  );
  return data;
}

export async function writeTenantSecret(
  slug: string,
  name: string,
  data: Record<string, string>,
): Promise<{ path: string; status: string }> {
  const r = await apiClient.put<{ path: string; status: string }>(
    `/admin/vault/${encodeURIComponent(slug)}/${encodeURIComponent(name)}`,
    { data },
  );
  return r.data;
}

export async function deleteTenantSecret(
  slug: string,
  name: string,
): Promise<{ path: string; status: string }> {
  const r = await apiClient.delete<{ path: string; status: string }>(
    `/admin/vault/${encodeURIComponent(slug)}/${encodeURIComponent(name)}`,
  );
  return r.data;
}
